import Combobox from '@/components/form/combobox';
import {DocumentInputField} from '@/engine/types';
import {useDocumentLocale} from '../../hooks/use-document-locale';
import {useSelectProps} from '../../hooks/use-select-props';
import {FieldProps} from '../../meta-field';

export const ComboboxField = (props: FieldProps<DocumentInputField>) => {
  const {_t} = useDocumentLocale();
  const {field, options, selectedOption, onChange, handleFocus, handleBlur} = useSelectProps(props);

  return (
    <Combobox
      id={field.id}
      data-testid={`${field.id}-control`}
      placeholder={_t(field.placeholder)}
      values={options}
      selectedValue={selectedOption}
      onChange={comboboxValue => onChange(comboboxValue?.value)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      isReadonly={field.readonly}
    />
  );
};
